<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication" style="margin-top:80px;"><span><i>For Aamir</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?63628d9b